import { defineComponent, PropType } from 'vue';
import { ClubUi } from '@/fairplayer/primary/club/Club.ui';
import { FairplayerImageVue } from '@/common/primary/fairplayer-image';
import { ImageResolution } from '@/common/primary/ImageResolution';

export default defineComponent({
  name: 'LiveAuctionPlatformNameCard',

  components: {
    FairplayerImageVue,
  },

  props: {
    club: {
      type: Object as PropType<ClubUi>,
      required: true,
    },
  },

  setup() {
    return {
      ImageResolution,
    };
  },
});
